import { Pipe, PipeTransform } from '@angular/core';
import { dateTransform } from '@modules/shared/pipes/ro-date';

@Pipe({
    name: 'roDate',
})
export class RoDatePipe implements PipeTransform {
    transform(
        date: string | Date,
        formatType:
            | 'time'
            | 'date'
            | 'friendly'
            | 'relative'
            | 'date-time'
            | 'long-date'
            | 'remaining'
            | string = 'date',
        fromUTC: boolean = false
    ): string {
        return dateTransform(date, formatType, fromUTC);
    }
}
